import { useEffect } from "react";
import "./PayPalSubscriptionButtons.scss"
import { trackPurchase } from "../../utils/facebookPixel";

export default function PayPalAnnuallyButtons({ setSubscriptionID, clientId, planId, isSandbox }) {
  useEffect(() => {

    if (!clientId || !planId) {
      console.error("🔍 STEP 5A.0: Missing clientId/planId for PayPal (Annually)");
      return;
    }

    const containerId = "paypal-button-container-" + planId;
    let cancelled = false;
    const script = document.createElement("script");
    script.src = "https://www.paypal.com/sdk/js?client-id=" + clientId + "&vault=true&intent=subscription";
    script.setAttribute("data-sdk-integration-source", "button-factory");
    script.addEventListener("load", () => {
      
      if (cancelled) return;
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
      if (window.paypal) {
        
        window.paypal.Buttons({
          style: {
            shape: "pill",
            color: isSandbox ? "white" : "gold",
            layout: "vertical",
            label: "paypal",
          },
          createSubscription: function (data, actions) {
            
            return actions.subscription.create({
              plan_id: planId,
            }).then((subscription) => {
              return subscription;
            }).catch((error) => {
              console.error("🔍 STEP 6A.6: PayPal annually subscription creation failed:", error);
              throw error;
            });
          },
          onApprove: function (data, actions) {
            setSubscriptionID(data.subscriptionID, planId);
            // Fire Purchase on approve; fetch real price if possible
            try {
              const backendUrl = `${process.env.REACT_APP_BACKEND_URL}/graphql`;
              const headers = { 'Content-Type': 'application/json' };
              const token = localStorage.getItem('token');
              if (token) headers['Authorization'] = `Bearer ${token}`;
              const body = JSON.stringify({
                query: `
                  query GetPaypalPlanDetails($planId: String!) {
                    getPaypalPlanDetails(planId: $planId)
                  }
                `,
                variables: { planId }
              });
              fetch(backendUrl, { method: 'POST', headers, credentials: 'include', body })
                .then(r => r.json())
                .then(j => {
                  const raw = j.data?.getPaypalPlanDetails;
                  const plan = (typeof raw === 'string') ? JSON.parse(raw) : raw;
                  const pricing = plan?.billing_cycles?.[0]?.pricing_scheme?.fixed_price;
                  const full = pricing?.value ? parseFloat(pricing.value) : 239.88;
                  const intervalUnit = plan?.billing_cycles?.[0]?.frequency?.interval_unit;
                  const perMonth = intervalUnit === 'YEAR' ? (full / 12) : full;
                  const currency = pricing?.currency_code || 'USD';
                  trackPurchase(parseFloat(perMonth.toFixed(2)), currency, { method: 'paypal', plan: 'annually' });
                })
                .catch(() => {
                  trackPurchase(19.99, 'USD', { method: 'paypal', plan: 'annually' });
                });
            } catch (_) {
              trackPurchase(19.99, 'USD', { method: 'paypal', plan: 'annually' });
            }
          },
          onError: function (err) {
            console.error("🔍 STEP 6A.11: PayPal Annually Error occurred:", err);
          },
          onCancel: function (data) {
            
          }
        }).render("#" + containerId).then(() => {
          
        }).catch((error) => {
          console.error("🔍 STEP 5A.8: PayPal annually button render failed:", error);
        });
      } else {
        console.error("🔍 STEP 5A.9: PayPal SDK not available after script load (Annually)");
      }
    });
    
    script.addEventListener("error", (error) => {
      console.error("🔍 STEP 5A.10: PayPal SDK script failed to load (Annually):", error);
    });
    
    document.body.appendChild(script);

    return () => {
      cancelled = true;
      try { document.body.removeChild(script); } catch (_) {}
    };
  }, [clientId, planId, isSandbox, setSubscriptionID]);

  return <div className="PayPalSubscriptionButtons" id={"paypal-button-container-" + planId}></div>;
}